import PromoShowcaseCard from '@moncler/components/listing/PromoShowcaseCard';
import React, { useEffect, useRef, useState } from 'react';
import SwiperCore, { Autoplay, EffectFade, EffectFlip, Keyboard, Navigation } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
SwiperCore.use([Keyboard, Navigation, Autoplay, EffectFade, EffectFlip]);
const PromoShowcase = (props) => {
    const card = typeof props.card === 'string' ? JSON.parse(props.card) : props.card;
    const componentCards = card.regions.promo_showcase_cards_container.components;
    const swiperRef = useRef();
    const [activeSlide, setActiveSlide] = useState();
    const [slidesLength, setSlidesLength] = useState();
    useEffect(() => {
        setSlidesLength(componentCards.length.toString().padStart(2, '0'));
    });
    const swiperConf = {
        // effect: 'fade' as const,
        // fadeEffect: {
        //   crossFade: true,
        // },
        // navigation: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        mousewheel: {
            forceToAxis: true,
            thresholdDelta: 20,
        },
        roundLengths: true,
        slidesPerView: 1,
        speed: 800,
        autoplay: {
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
            delay: 5000,
        },
        loop: true,
        modules: [Navigation],
    };
    return (React.createElement("div", { className: `promo-showcase promo-showcase__carousel row ${componentCards.length <= 1 && 'single-card'}` },
        React.createElement("div", { className: "col-md-12 promo-showcase__container" },
            componentCards.length <= 1 && React.createElement(PromoShowcaseCard, { card: componentCards[0] }),
            componentCards.length > 1 && (React.createElement(React.Fragment, null,
                React.createElement(SwiperInstance, Object.assign({ className: "promo-showcase__cards-swiper" }, swiperConf, { onSwiper: (swiper) => {
                        swiperRef.current = swiper;
                    }, onActiveIndexChange: (swiper) => setActiveSlide((swiper.realIndex + 1).toString().padStart(2, '0')) }),
                    componentCards.map((promoCard, i) => {
                        return (React.createElement(SwiperSlide, { key: i },
                            React.createElement(PromoShowcaseCard, { card: promoCard, slideIndex: i + 1, carouselDescription: card.description_analytics || card.description })));
                    }),
                    React.createElement("div", { className: "swiper-pagination swiper-pagination--bars container" })),
                React.createElement("div", { className: "promo-showcase__slides-number container" },
                    React.createElement("p", { className: "primary-s" },
                        card.description,
                        ' ',
                        React.createElement("span", null,
                            activeSlide,
                            "/",
                            slidesLength))))))));
};
export default PromoShowcase;
